import { gsap, ScrollTrigger } from './gsap';

export function initNewsletterPopup() {
    const triggers = [ ...document.querySelectorAll( '[data-newsletter-popup-trigger]' ) ];
    const popup    = document.getElementById( 'newsletter-popup' );
    if ( ! triggers.length || ! popup ) return;

    const overlay  = popup.querySelector( '.newsletter-popup__overlay' );
    const closeBtn = popup.querySelector( '.newsletter-popup__close' );
    const dialog   = popup.querySelector( '.newsletter-popup__dialog' );
    let lastTrigger = null;

    function open( trigger ) {
        lastTrigger = trigger;
        gsap.set( dialog,  { y: 48, opacity: 0 } );
        gsap.set( overlay, { opacity: 0 } );
        popup.removeAttribute( 'hidden' );
        document.body.style.overflow = 'hidden';
        gsap.to( overlay, { opacity: 1, duration: 0.3, ease: 'none' } );
        gsap.to( dialog,  { y: 0, opacity: 1, duration: 0.45, ease: 'power3.out', onComplete: () => closeBtn.focus() } );
    }

    function close() {
        gsap.to( overlay, { opacity: 0, duration: 0.25, ease: 'none' } );
        gsap.to( dialog,  {
            y: 48, opacity: 0, duration: 0.3, ease: 'power3.in',
            onComplete() {
                popup.setAttribute( 'hidden', '' );
                document.body.style.overflow = '';
                if ( lastTrigger ) lastTrigger.focus();
            },
        } );
    }

    triggers.forEach( ( t ) => t.addEventListener( 'click', ( e ) => { e.preventDefault(); open( t ); } ) );
    overlay.addEventListener( 'click', close );
    closeBtn.addEventListener( 'click', close );

    document.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Escape' && ! popup.hasAttribute( 'hidden' ) ) close();
    } );
}

export function initNewsletter() {
    const section = document.querySelector( '[data-newsletter]' );
    if ( ! section ) return;

    const bg    = section.querySelector( '[data-newsletter-bg]' );
    if ( ! bg ) return;

    const inner = section.querySelector( '.newsletter__inner' );

    const fromVars = () => {
        const sW = section.offsetWidth  || 1;
        const sH = section.offsetHeight || 1;
        const iH = inner ? inner.offsetHeight : sH * 0.4;
        return {
            scaleX: Math.min( 1, 628 / sW ),
            scaleY: Math.min( 1, iH / sH ),
        };
    };

    const setInitial = () => {
        const { scaleX, scaleY } = fromVars();
        gsap.set( bg, {
            scaleX,
            scaleY,
            borderRadius:    '32px',
            transformOrigin: 'center center',
            opacity:         1,
        } );
    };

    setInitial();

    gsap.to( bg, {
        scaleX:       1,
        scaleY:       1,
        borderRadius: '0px',
        ease:         'none',
        scrollTrigger: {
            trigger:       section,
            start:         'center center',
            end:           '+=600',
            pin:           true,
            scrub:         true,
            anticipatePin: 1,
            onRefresh( self ) {
                // 1. Reset to initial so tween re-records correct "from" values
                setInitial();
                // 2. Re-capture "from" based on current element state
                self.animation.invalidate();
                // 3. Immediately seek to correct position for current scroll
                self.animation.progress( self.progress );
            },
        },
    } );
}
